const R = 6371008.8; // mean Earth radius (m)
const rad = (d: number) => (d * Math.PI) / 180;

/** Great-circle distance in metres. */
export function haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const dLat = rad(lat2 - lat1);
  const dLon = rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
}

export type BBox = [west: number, south: number, east: number, north: number];

/** Bounding box of a circle (for SQL prefiltering before exact haversine). */
export function bboxAround(lat: number, lon: number, radiusM: number): BBox {
  const dLat = radiusM / 111_320;
  const dLon = radiusM / (111_320 * Math.max(0.01, Math.cos(rad(lat))));
  return [lon - dLon, lat - dLat, lon + dLon, lat + dLat];
}

/** Pyrenees + pre-Pyrenees catalog bbox. */
export const PYRENEES_BBOX: BBox = [-2.0, 41.9, 3.4, 43.4];
export const PYRENEES_CENTER: [number, number] = [0.65, 42.65];

export function parseBBox(s: string | null | undefined): BBox | null {
  if (!s) return null;
  const p = s.split(",").map(Number);
  if (p.length !== 4 || p.some((n) => !Number.isFinite(n))) return null;
  const [w, so, e, n] = p as BBox;
  if (w >= e || so >= n || so < -90 || n > 90 || w < -180 || e > 180) return null;
  return [w, so, e, n];
}

/** Dedupe radius for "same peak" detection. */
export const DEDUPE_RADIUS_M = 150;
